import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const componentsDetailPageNotFoundModal: CMSApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_CMS_API}/components-detail-page-not-found-modal`
  ),
};

export default componentsDetailPageNotFoundModal;
